import React, { Fragment, useCallback, ChangeEvent } from 'react';
import cl from 'classnames';

import { Translate } from '../../../../../helpers/Translate';

import {
  CheckBoxDateAtFieldControlRequiredProps,
  CheckBoxDateAtFieldControlValue
} from './CheckBoxDateAtFieldControl.types';

interface CheckBoxDateAtFieldControlProps {
  value: CheckBoxDateAtFieldControlValue;
  onChange: (value: CheckBoxDateAtFieldControlValue) => void;
}

function CheckBoxDateAtFieldControl({
  value,
  error,
  disabled,
  className,
  checkBoxClassName,
  id,
  required,
  i18nLabel,
  label,
  labelClassName,
  errorClassName,
  name,
  onChange
}: CheckBoxDateAtFieldControlProps & CheckBoxDateAtFieldControlRequiredProps) {
  const handleChange = useCallback<(e: ChangeEvent<HTMLInputElement>) => void>(
    (e) => {
      const isChecked = e?.target?.checked;
      onChange(isChecked ? new Date().toJSON() : null);
    },
    [onChange]
  );
  return (
    <Fragment>
      <div className={cl(className || 'flex items-center')}>
        <input
          className={cl(checkBoxClassName || 'basic-checkbox', {
            'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500 dark:focus:border-red-500 dark:border-red-700':
              error
          })}
          disabled={disabled}
          id={id}
          name={name}
          onChange={handleChange}
          required={required}
          type="checkbox"
          checked={!!value}
        />

        {i18nLabel || label ? (
          <label
            htmlFor={id}
            className={cl(
              labelClassName ||
                'ml-2 block text-sm text-gray-900 dark:text-gray-100'
            )}
          >
            {i18nLabel ? <Translate id={i18nLabel} /> : label}
          </label>
        ) : null}
      </div>

      {error && (
        <p className={cl(errorClassName || 'mt-2 text-sm text-red-600')}>
          {/^forms\.errors+/.test(error) ? <Translate id={error} /> : error}
        </p>
      )}
    </Fragment>
  );
}

export default CheckBoxDateAtFieldControl;
